import {
  AiResponseEncodedUiComponents,
  ChatEncoding,
  ChatMessageAiAnswerSource,
  ENCODING_SPECIAL_CHAR,
} from '@worknet/models';

import { encodeComponentMarker } from './componentMarkers';

export class ChatContentParser {
  private content: string = '';
  private lastContent: string = '';
  private tmpBuffer: string | undefined = undefined;

  public constructor(private handleSpecialChunk: (chunk: string) => string) {}

  public handleNewContent(newContent: string) {
    const diff = newContent.slice(this.lastContent.length);
    this.lastContent = newContent;

    for (const c of diff) {
      if (this.tmpBuffer !== undefined) {
        if (c === ENCODING_SPECIAL_CHAR) {
          this.content += this.handleSpecialChunk(this.tmpBuffer);
          this.tmpBuffer = undefined;
        } else {
          this.tmpBuffer += c;
        }
      } else {
        if (c === ENCODING_SPECIAL_CHAR) {
          this.tmpBuffer = '';
        } else {
          this.content += c;
        }
      }
    }

    return this.content;
  }
}

export class StripAllParser extends ChatContentParser {
  constructor() {
    super(() => {
      return '';
    });
  }
}

export function parseFullChat(text: string) {
  const sources: ChatMessageAiAnswerSource[] = [];
  const components: AiResponseEncodedUiComponents[] = [];
  const cites: (string | number)[] = [];
  const parser = new ChatContentParser((chunk) => {
    const decoded = safeJSONParse<ChatEncoding>(chunk);
    switch (decoded?.type) {
      case 'sources':
        sources.push(...decoded.sources);
        return '';
      case 'cite':
        cites.push(decoded.id);
        return encodeComponentMarker({ kind: 'cite', id: decoded.id.toString() });
      case 'ui-components':
        components.push(decoded.component);
        return '';
      default:
        console.error('Unknown source type:', decoded satisfies undefined);
        return '';
    }
  });
  const content = parser.handleNewContent(text);
  const citesByKey = Object.fromEntries(cites.map((c) => [c.toString(), true]));
  const referencedSources = sources.filter(
    (source, idx) => citesByKey[source.id?.toString() ?? idx.toString()]
  );
  return {
    content,
    sources: referencedSources,
    components,
  };
}

function safeJSONParse<T>(jsonString: string): T | undefined {
  try {
    return JSON.parse(jsonString) as T;
  } catch (error) {
    return undefined;
  }
}
